<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.Interest") }}</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-plus"
        @click="addInterestPart()"
        icon-pack="feather"
        >Add Interests</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col">
          <vs-input
            label="Title"
            v-model="title"
            class="w-full"
            name="interest"
            v-validate="'required|min:3|max:35'"
          />
          <span class="text-danger text-sm" v-show="errors.has('interest')">{{
            errors.first("interest")
          }}</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <p class="p-input-text">{{ $t("labels.image_upload") }}</p>
          <div class="uploaded-image pt-3">
            <div v-if="profile_pic">
              <a href="#">
                <img
                  src="@/assets/images/edit-cut-image.png"
                  @click.prevent="removeTestimonialPhoto(profile_pic)"
                  class="img-fluid close-arrow-teacher"
                  alt
                />
              </a>
              <div class="upload_document">
                <a :href="profile_pic" target="_blank">
                  <img :src="profile_pic" class="img-fluid edit-main-img" alt />
                </a>
              </div>
            </div>
            <label for="file-input" v-if="profile_pic < 1">
              <img
                src="@/assets/images/upload.png"
                class="img-fluid edit-main-img cursor-pointer"
                @click.prevent="SelectTestimonialImage()"
                else
              />
            </label>
            <br />
          </div>
          <span class="text-danger text-sm">{{
            errors.first("InterestfileUpload")
          }}</span>
          <input
            type="hidden"
            v-model="profile_pic"
            v-validate="'required'"
            name="InterestfileUpload"
          />
          <vue-image-upload
            field="img"
            ref="imageupload"
            @crop-success="uploadTstimonialImage"
            v-model="show_Testimonial_Image"
            v-validate="'required'"
            :width="156"
            :height="117"
            :maxSize="10000"
            lang-type="en"
            img-format="png"
            name="InterestfileUpload"
          ></vue-image-upload>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            v-if="create"
            color="success"
            class="mr-3 mb-2"
            id="new-interest"
            :disabled="button_loading || !profile_pic"
            @click="addNewInterest()"
            >Add</vs-button
          >
          <vs-button
            v-if="editInterestButton"
            color="success"
            id="edit-interest"
            class="mb-2 mr-3"
            @click="editInterestData()"
            >Edit</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="closeData()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="closePopup()"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table stripe :data="users" search max-items="10">
        <template slot="thead">
          <vs-th>{{ $t("labels.sr_no") }}</vs-th>
          <vs-th>{{ $t("labels.title") }}</vs-th>
          <vs-th>{{ $t("labels.image") }}</vs-th>
          <vs-th>{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].sr_no }}
            </vs-td>

            <vs-td :data="data[indextr].code">
              {{ data[indextr].code }}
            </vs-td>

            <vs-td :data="data[indextr].image">
              <!-- {{ data[indextr].image }} -->
              <a
                :href="data[indextr].image"
                target="_blank"
                class="float-left mr-1"
              >
                <div class="img-container mb-4">
                  <vs-avatar size="100px" v-bind:src="data[indextr].image" />
                </div>
              </a>
            </vs-td>

            <vs-td :data="data[indextr].email">
              <span>
                <vs-button
                  title="Delete"
                  class="m-1 float-left"
                  color="danger"
                  size="small"
                  icon="icon-trash-2"
                  @click="DeleteInterest(data[indextr].id)"
                  icon-pack="feather"
                ></vs-button>
                <vs-button
                  v-if="data[indextr].status"
                  size="small"
                  @click.native="
                    editInterest(
                      data[indextr].code,
                      data[indextr].image,
                      data[indextr].id
                    )
                  "
                  title="Edit"
                  class="m-1 float-left"
                  color="black"
                  icon="icon-edit"
                  icon-pack="feather"
                ></vs-button>
              </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div style="height: 50px">
      <div class="float-left mt-5">
        <vs-pagination
          ref="paginationContact"
          :total="totalPage"
          v-model="currentPage"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import VueImageUpload from "vue-image-crop-upload";
export default {
  components: {
    VueImageUpload,
    "v-select": vSelect,
  },
  data: () => ({
    editInterestButton: false,
    create: true,
    data_hide: false,
    users: [],
    title: "",
    changeID: null,
    deleteID: null,
    Des_popup: false,
    editID: null,
    description: "",
    name: "",
    profile_pic: "",
    TestimonialAddEdit: false,
    popupActive: false,
    testimonials: [],
    TestimonialIndex: null,
    show_Testimonial_Image: false,
    demo_image: null,
    currentPage: 1,
    editFlag: false,
    addFlag: false,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getAllTeacher();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllTeacher();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllTeacher();
      }
    },
  },
  methods: {
    editInterest(title, profile_pic, Id) {
      if (this.editFlag == false && this.addFlag == false) {
        this.data_hide = !this.data_hide;
      }

      this.title = title;
      this.profile_pic = profile_pic;
      this.editInterestButton = true;
      this.create = false;
      this.editID = Id;
      this.editFlag = true;
      window.scrollTo(0, 0);
    },
    getAllTeacher() {
      let input = {
        title: this.title,
        page: this.currentPage,
        perPage: this.perPage,
      };
      axios
        .post("admin/allInterests", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.interests;
          this.totalPage = Math.ceil(data.count / this.perPage);
          let page = this.$route.query.page;
          if (page) {
            this.currentPage = page;
          }
          console.log(this.users);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    SelectTestimonialImage() {
      this.show_Testimonial_Image = !this.show_Testimonial_Image;
      this.createImgUrl = null;
    },
    TestimonialImageUrl(dataurl) {
      console.log(dataurl);
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], "image", { type: mime });
    },
    uploadTstimonialImage(imgDataUrl) {
      this.demo_image = imgDataUrl;
      let index = this.TestimonialIndex;
      let fileimage = this.TestimonialImageUrl(imgDataUrl);
      var formdata = new FormData();
      formdata.append("directory_name", "interest");
      formdata.append("attachment", fileimage);
      axios
        .post("user/uploadToS3", formdata)
        .then((response) => {
          let data = response.data.data;
          if (response) {
            console.log(response);
            this.profile_pic = data.url;
            this.$refs.imageupload.step = 1;
            console.log(this.profile_pic);
          }
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    removeTestimonialPhoto(profile_pic) {
      let input = {
        fileUrl: profile_pic,
      };
      axios
        .post("user/removeFile", input)
        .then((response) => {
          this.profile_pic = null;
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    addNewInterest() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.button_loader(true, "#new-interest");
          let input = {
            code: this.title,
            image: this.profile_pic,
          };
          axios
            .post("admin/addInterests", input)
            .then((response) => {
              let data = response.data;
              console.log(data);
              this.$vs.notify({
                text: data.message,
                color: "success",
                position: "top-right",
              });
              this.getAllTeacher();
              this.button_loader(false, "#new-interest");
              this.data_hide = !this.data_hide;
              this.title = "";
              this.profile_pic = "";
              this.editFlag = false;
              this.addFlag = false;
            })
            .catch((e) => {
              this.showError(e);
              this.button_loader(false, "#new-interest");
            });
        }
      });
    },
    DeleteInterest(id) {
      this.deleteID = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("labels.delete_interest"),
        text: this.$t("strings.delete_interest"),
        acceptText: this.$t("labels.delete_button"),
        accept: this.deleteUser,
      });
    },
    deleteUser() {
      let id = this.deleteID;
      axios
        .get("admin/deleteInterest/" + id)
        .then((response) => {
          let data = response.data;
          this.getAllTeacher();
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });

          this.deleteID = null;
        })
        .catch((e) => {
          this.deleteID = null;
          this.showError(e);
        });
    },
    editInterestData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.button_loader(true, "#edit-interest");
          let input = {
            id: this.editID,
            code: this.title,
            image: this.profile_pic,
          };
          axios
            .post("admin/editInterest", input)
            .then((response) => {
              let data = response.data;
              console.log(data);
              this.$vs.notify({
                text: data.message,
                color: "success",
                position: "top-right",
              });
              this.getAllTeacher();
              this.button_loader(false, "#edit-interest");
              this.data_hide = !this.data_hide;
              this.title = "";
              this.profile_pic = "";
              this.editInterestButton = false;
              this.create = true;
              this.editFlag = false;
              this.addFlag = false;
            })
            .catch((e) => {
              this.showError(e);
              this.button_loader(false, "#edit-interest");
            });
        }
      });
    },
    closeData() {
      this.title = "";
      this.profile_pic = "";
      this.editInterestButton = false;
      this.create = true;
      this.$validator.reset();
      this.errors.clear();
      this.editFlag = false;
      this.addFlag = false;
    },
    closePopup() {
      this.data_hide = !this.data_hide;
      this.editFlag = false;
      this.addFlag = false;
    },
    addInterestPart() {
      console.log(this.editFlag);
      if (this.editFlag == true) {
        this.title = "";
        this.profile_pic = "";
        this.editInterestButton = false;
        this.create = true;
        this.$validator.reset();
        this.errors.clear();
      } else {
        this.data_hide = !this.data_hide;
        this.$validator.reset();
        this.errors.clear();
      }
      this.addFlag = true;
    },
    getIndexCount(number) {
      return this.currentPage - 1 + "" + (number - 1);
    },
  },
  mounted() {
    this.getAllTeacher();
    this.setValidationMessage();
  },
};
</script>

<style lang="scss" scoped>
</style>